import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDoupleCheckmark1Small: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="douple-checkmark-1-small"><path d="M5.75 13.0625L8.9375 16.25L14.25 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 16.5L18.25 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDoupleCheckmark1Small;
